import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import store from "@/store";

const name = "snackbar";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((store.state as any)[name]) {
  store.unregisterModule(name);
}

export enum SnackbarType {
  SUCCESS = "success",
  ERROR = "error",
}

/**
 * Global snackbar state module.
 * Components call SnackbarModule.showSuccess() or SnackbarModule.showError()
 * instead of managing local snackbar properties. The single v-snackbar lives
 * in Scaffold.vue and reads from this module.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class SnackbarVuexModule extends VuexModule {
  visible = false;
  i18nKey = "";
  i18nParams: string[] = [];
  type: SnackbarType = SnackbarType.SUCCESS;
  timeout = 5000;

  get snackbarColor() {
    return this.type === SnackbarType.SUCCESS ? "green" : "red";
  }

  @Mutation
  showSuccess(payload: { key: string; params?: string[] }) {
    this.visible = true;
    this.i18nKey = payload.key;
    this.i18nParams = payload.params ?? [];
    this.type = SnackbarType.SUCCESS;
  }

  @Mutation
  showError(payload: { key: string; params?: string[] }) {
    this.visible = true;
    this.i18nKey = payload.key;
    this.i18nParams = payload.params ?? [];
    this.type = SnackbarType.ERROR;
  }

  @Mutation
  hide() {
    this.visible = false;
  }
}

export const SnackbarModule = getModule(SnackbarVuexModule);
